import { Component } from '@angular/core';

@Component({
  selector: 'app-pending-krk-list',
  templateUrl: './pending-krk-list.component.html',
  styleUrls: ['./pending-krk-list.component.scss']
})
export class PendingKrkListComponent {

}
